var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "pb24",
    },
    [
      _vm.tagData.length > 0
        ? _c(
            "div",
            _vm._l(_vm.tagData, function (item, index) {
              return _c("dl", { key: index, staticClass: "yxtbiz-tag-dl" }, [
                _c("dt", { staticClass: "color-gray-10 font-size-14" }, [
                  _c("span", { staticClass: "font-medium" }, [
                    _vm._v(_vm._s(item.groupName)),
                  ]),
                  _c("span", { staticClass: "color-gray-8" }, [
                    _vm._v(
                      "（" +
                        _vm._s(
                          item.choiceType === 2
                            ? _vm.$t("pc_biz_utility_tip_multiChoice")
                            : _vm.$t("pc_biz_utility_tip_singleChoice")
                        ) +
                        "）"
                    ),
                  ]),
                ]),
                _c(
                  "dd",
                  [
                    _c("tag-group", {
                      attrs: {
                        "group-id": item.id,
                        multi: item.choiceType === 2,
                        data: item.tags,
                      },
                      model: {
                        value: _vm.selected,
                        callback: function ($$v) {
                          _vm.selected = $$v
                        },
                        expression: "selected",
                      },
                    }),
                  ],
                  1
                ),
              ])
            }),
            0
          )
        : _c("yxt-empty"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }